/* unplugin-vue-components disabled */import { render } from "./NotificationsDashboard.vue?vue&type=template&id=1b48a022"
import script from "./NotificationsDashboard.vue?vue&type=script&lang=js"
export * from "./NotificationsDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__